import { SVGProps } from "react";

const ChevronUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={10}
    height={6}
    viewBox="0 0 10 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.73869 4.5L5.55332 1.7441C5.17714 1.41863 4.56156 1.41863 4.18537 1.7441L1 4.5"
      stroke="currentColor"
      strokeWidth={1.4}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default ChevronUp;
